import { isProvider } from "../utils/storage";

function HideForProvider({ children }) {
    if (isProvider) {
        return null;
    }
    return children;
}

export default HideForProvider;